function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseHover = function SvgCloseHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m565.4 512 350.7-350.7c14.7-14.7 14.7-38.6 0-53.4-14.7-14.7-38.7-14.7-53.4 0L512 458.6 161.3 108c-14.7-14.7-38.6-14.7-53.4 0-14.7 14.7-14.7 38.6 0 53.4L458.6 512 108 862.6c-14.7 14.7-14.7 38.7 0 53.4 7.4 7.4 17 11 26.7 11s19.3-3.7 26.7-11L512 565.4 862.6 916c7.4 7.4 17 11 26.7 11s19.3-3.7 26.7-11c14.7-14.7 14.7-38.7 0-53.4L565.4 512z",
    style: {
      fill: "#333"
    }
  }));
};
export default SvgCloseHover;